import {
  fetchStatsSensorApi
} from "../../../api/reports/co2";

export default {
  fetchStatsSensor({ commit }, a) {
    // возвращает все виды статусов emissions
    return new Promise((resolve, reject) => {
      fetchStatsSensorApi(a)
        .then(res => {
          commit("SET_ONLINE_CO2_STATS", res.data)
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

};
